// TOP LEVEL IMPORTS
import React from 'react';
import moment, { isMoment } from 'moment';
// ANTD
import DateInput from 'components/inputs/DateInput';
// HELPERS
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
// COMPONENTS

// CONSTANTS & DESTRUCTURING
// ==========================
const FONT_SIZE = 17;

// STYLES
// ==========================

// EXPORTED COMPONENT
// ==========================
class FinalPaymentSection extends React.PureComponent {
  render() {
    const { record, currencySymbol } = this.props;

    return (
      <div>
        <div>
          After the deposit of
          <span className="money-green">
            {' '}
            {CurrencyHelpers.centsToDollars(record.depositAmount, { symbol: currencySymbol })}
          </span>
          , the final payment of
          <span className="money-green">
            {' '}
            {CurrencyHelpers.centsToDollars(record.finalPaymentAmount, { symbol: currencySymbol })}{' '}
          </span>
          is due on
          <span style={{ padding: 4 }}>
            <DateInput
              value={record.finalPaymentDueDate}
              onChange={finalPaymentDueDate => this.props.onChange({ finalPaymentDueDate })}
            />
          </span>
          .
        </div>
      </div>
    );
  }
}

export default FinalPaymentSection;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/PricingInfo/FinalPaymentSection/index.js